let locales = {
    "httpLogs_menu": "Registro errori HTTP",
};

// merge modal SubmitDocument
import list from '../../views/list/lan/it'

locales = {
    ...locales,
    ...list,
};

export default locales;